//test
export const getCount = state => {
    return state.count
}

export const getToken = state => {
    return state.uptoken
}

export const getCurrentIndex = state => {
    return state.currentIndex
}

export const getTopicArr = state => {
    return state.topicArr
}

export const getProductArr = state => {
    return state.productArr
}

export const getCategoryArr = state => {
    return state.categoryArr
}

export const getLocalBanner = state => {
    return state.localBanner
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js